import { defineStore } from 'pinia'

export const useCartStore = defineStore('cart', {
    state: () => ({ cart: {}}),
    actions: {
        load(cart) {
            this.cart = cart;
        },
    },
})